import { createApiSlice } from "@common";
import { MY_INFO_DOCUMENT_STATUS_CONFIG } from "@routes";

const apiConfig = [
  {
    name: "addDocumentStatus",
    method: "post",
    url: MY_INFO_DOCUMENT_STATUS_CONFIG,
    stateKey: "message",
  },

  {
    name: "getDocumentStatus",
    method: "get",
    url: MY_INFO_DOCUMENT_STATUS_CONFIG,
    stateKey: "data",
  },

  {
    name: "updateDocumentStatus",
    method: "put",
    url: MY_INFO_DOCUMENT_STATUS_CONFIG,
    stateKey: "message",
  },

  {
    name: "deleteDocumentStatus",
    method: "delete",
    url: MY_INFO_DOCUMENT_STATUS_CONFIG,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("documentStatus", apiConfig, customReducers);
const documentStatusSlice = slice;

export default documentStatusSlice.reducer;

export const {
  addDocumentStatus,
  getDocumentStatus,
  updateDocumentStatus,
  deleteDocumentStatus,
} = thunks;

export const { rowSelect } = actions;
